import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchProgressPhotosData,
  type ProgressPhoto,
} from "../../services/api/progressPhotosService";

// ─── Async Thunk ─────────────────────────────────────────────────────
export const fetchProgressPhotos = createAsyncThunk(
  "progressPhotos/fetchProgressPhotos",
  async (projectId: string | undefined, { rejectWithValue }) => {
    try {
      const photos = await fetchProgressPhotosData(projectId);
      return { photos, projectId };
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch progress photos");
    }
  }
);

// ─── State ───────────────────────────────────────────────────────────
interface ProgressPhotosState {
  photos: ProgressPhoto[];
  status: "idle" | "loading" | "succeeded" | "failed";
  currentProjectId: string | undefined;
}

const initialState: ProgressPhotosState = {
  photos: [],
  status: "idle",
  currentProjectId: undefined,
};

// ─── Slice ───────────────────────────────────────────────────────────
const progressPhotosSlice = createSlice({
  name: "progressPhotos",
  initialState,
  reducers: {
    resetProgressPhotos: (state) => {
      state.photos = [];
      state.status = "idle";
      state.currentProjectId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProgressPhotos.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProgressPhotos.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.photos = action.payload.photos;
        state.currentProjectId = action.payload.projectId;
      })
      .addCase(fetchProgressPhotos.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { resetProgressPhotos } = progressPhotosSlice.actions;
export default progressPhotosSlice.reducer;
